import React from "react";

//Toast
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//Router
import { BrowserRouter } from "react-router-dom";

//Custom routes
import RootRoutes from "Routes/RootRoutes";

function App() {
  return (
    <BrowserRouter>
      <RootRoutes />
      <ToastContainer
        position="top-right" // Position of the toast
        autoClose={4000} // Auto-close the toast after 5 seconds
        hideProgressBar={false} // Show or hide the progress bar
        newestOnTop={false} // Display new toasts on top
        closeOnClick // Close the toast when clicked
        rtl={false} // Right-to-left layout support
        pauseOnFocusLoss={false} // Pause toast when window is not focused
        draggable={false} // Allow the toast to be draggable
        pauseOnHover={false} // Pause toast on hover
        theme="light" // Light or dark theme
      />
    </BrowserRouter>
  );
}

export default App;
